import { createAsyncThunk } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { actionService } from '../../services/actionService'
import {
  GET_ACTIONS_DATA,
  GET_EXECUTABLE_TRANSITION_DATA,
  GET_PARENT_ACTIONS_DATA,
} from '../config'
import { IExecutableTransitionParams, IRequestActionParams } from '../models'
import { selectActionsLoadingStatus } from '../selectors/selectActionsData'

import { handleApiResponse } from './helpers/handleApiResponse'

class ActionApi {
  public getActions = createAsyncThunk(
    GET_ACTIONS_DATA,
    async ({ requestId }: IRequestActionParams, _thunkAPI) => {
      const response = await actionService.fetchActions(requestId)
      return handleApiResponse(response)
    },
    {
      condition({ requestId }, { getState }) {
        if (!requestId) {
          return false
        }

        const state = getState() as any
        const status = selectActionsLoadingStatus(state)
        if (status === RequestStatus.PENDING) {
          return false
        }

        return
      },
    }
  )

  public getParentActions = createAsyncThunk(
    GET_PARENT_ACTIONS_DATA,
    async ({ requestId }: IRequestActionParams, _thunkAPI) =>
      await actionService.fetchActions(requestId, 1)
  )

  public getExecutableTransitions = createAsyncThunk(
    GET_EXECUTABLE_TRANSITION_DATA,
    async ({ requestId }: IExecutableTransitionParams, _thunkAPI) =>
      await actionService.getExecutableTransitions(requestId)
  )
}

export const actionApi = new ActionApi()
